// ESTE METODO SIRVE PARA HACER ESPERAR UN PROCESO N TIEMPO EN MILISEGUNDOS

export default time => {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve(true)
    }, time)
  })
}
